/**
 * WEB-685 — single source of truth for icon_with_text's iconName -> emoji
 * mapping, shared by BlockPropertiesPanelExtended (icon picker) and
 * PublicBlockRendererExtended (renders the glyph). Kept in a standalone
 * module (no antd/React import) so the public renderer's bundle does not
 * pull in the properties-panel's antd dependencies.
 */

export const ICON_EMOJI_MAP: Record<string, string> = {
  star: '★',
  heart: '♥',
  check: '✓',
  info: 'ℹ',
  warning: '⚠',
  fire: '🔥',
  bolt: '⚡',
  gift: '🎁',
  lock: '🔒',
  shield: '🛡',
  search: '🔍',
  clock: '⏰',
  calendar: '📅',
  money: '💰',
  chart: '📈',
  trophy: '🏆',
  rocket: '🚀',
  bulb: '💡',
  phone: '📞',
  mail: '✉️',
  paperclip: '📎',
};

export const DEFAULT_ICON_EMOJI = ICON_EMOJI_MAP.star;

export function getIconEmoji(iconName?: string): string {
  if (!iconName) return DEFAULT_ICON_EMOJI;
  return ICON_EMOJI_MAP[iconName] ?? DEFAULT_ICON_EMOJI;
}
